import { render, staticRenderFns } from "./ContactName.vue?vue&type=template&id=b5633b9a&scoped=true"
import script from "./ContactName.vue?vue&type=script&lang=js"
export * from "./ContactName.vue?vue&type=script&lang=js"
import style0 from "./ContactName.vue?vue&type=style&index=0&id=b5633b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5633b9a",
  null
  
)

export default component.exports